import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddToCart from './AddToCart';
import { ReadMore } from './Utils';
import { useStore } from '../useStore';
import { TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { cartSetProductSearch } from '../reducers/cart';


const ProductFilter = ({search, setSearch}) => {
  return (
    <TextField
      //label="Sök produktnamn"
      value={search}
      onChange={event => {setSearch(event.target.value)}}
      
      InputProps={{
        startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>
      }}
      inputProps={{
        placeholder: 'Sök produktnamn'
      }}
      >
    </TextField>
  )
}
const ProductList = ({ brewery, crud }) => {
  const { state, dispatch } = useStore();
  const { cart } = state;
  const search = cart.productSearch;
  const searchLower = (search || '').toLowerCase();

  useEffect(() => {
    crud.getItems({
      filter: {
        brewery: brewery.id,
      }
    });
  }, []);

  if (crud.isLoading) {
    return (
      <div style={{ textAlign: "center" }}>
        <CircularProgress />
      </div>
    );
  } else {
    if (!crud.items) {
      return (
        <Typography align="center">Inga produkter att visa.</Typography>
      );
    } else {
      return (
        <Grid container direction="column" alignItems="center">
          <Grid item xs={11} sm={10} md={8} lg={6} xl={4}>
            <Grid container direction="column" spacing={16} alignItems="stretch">
              <ProductFilter search={search} setSearch={productSearch => dispatch(cartSetProductSearch(productSearch))} />
              {(searchLower === '' ? crud.items : crud.items.filter(item => item.title.toLowerCase().includes(searchLower))).map(item => (
                <Grid item key={item.id}>
                  <Card item={item}>
                  {item.thumbnail && <div style={{textAlign: 'center'}}>
                       <img src={item.thumbnail} />
                    </div>
                  }
                    <CardHeader title={`${item.title} [${item.sku}]`} />
                    <CardContent>
                      <Typography>
                        <ReadMore readMoreText="Läs mer" lines={1}>
                          <span dangerouslySetInnerHTML={{ __html: item.description }}></span>
                        </ReadMore>
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <AddToCart brewery={brewery} item={item} cart={cart} dispatch={dispatch} />
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      );
    }
  }
}
export default ProductList;
